export function emptyToUndefined<T>(value: "" | T) {
	if (value === "") {
		return;
	}

	return value;
}
